import { useMemo } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type AnalyticalFieldMappingFieldType } from '../../bookkeep';

export const useFieldTypeDescription = (
  fieldType: AnalyticalFieldMappingFieldType | undefined,
) => {
  const { t } = useTranslation('global');
  return useMemo(() => {
    switch (fieldType) {
      case 'costCenter':
        return t('accounting-integration.exportSettings.fieldTypes.costCenter');
      case 'expenseCategory':
        return t(
          'accounting-integration.exportSettings.fieldTypes.expenseCategory',
        );
      case 'customField':
        return t(
          'accounting-integration.exportSettings.fieldTypes.customField',
        );
      default:
        return '';
    }
  }, [fieldType]);
};
